import { http } from '../../config/axios'

 const findNotificacaoFatura = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/notificacao-fatura/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findNotificacaoFatura', error)
      throw Error(error.response.data)
    })
}

export default findNotificacaoFatura;
